import React, {FC, useContext} from "react";
import {AuthContext} from "contexts";
import {blackListService, BlackListUser} from "services/blackListService";
import {UpdateBlackListModal} from "./UpdateBlackListModal";

interface Props {
    isModalVisible: boolean;
    setIsModalVisible: (v: boolean) => void;
    selectedUser: BlackListUser | null;
    onSave: () => void
}

export const AddPhotosBlackListModal: FC<Props> = ({
                                                       isModalVisible,
                                                       setIsModalVisible,
                                                       selectedUser,
                                                       onSave
                                                   }) => {
    const {env} = useContext(AuthContext);

    const handleSave = async ({photos}: { photos: File[] }) => {
        if (!env || !selectedUser) {
            return
        }
        await blackListService.addPhotos(env, {key: selectedUser.userKey, files: photos});
        onSave()
    }

    return (
        <UpdateBlackListModal
            isModalVisible={isModalVisible}
            setIsModalVisible={setIsModalVisible}
            handleSave={handleSave}
            selectedUser={selectedUser}
        />
    )
}